import { SystemLoadingSurface } from '@/components/ui/SystemLoading';
interface OctoLoaderProps { size?: number; className?: string; text?: string; }
/** Backwards-compatible entry points for the shared conversation loading artwork. */
export function OctoLoader({ size = 48, className = '', text = 'Loading...' }: OctoLoaderProps) {
  return <div role="status" className={`flex flex-col items-center justify-center gap-3 ${className}`}>
    <SystemLoadingSurface className="rounded-lg" style={{width: size * 1.5, height: size}} />
    {text && <span className="text-gray-500 text-sm">{text}</span>}
  </div>;
}
export const LepusLoader = OctoLoader;
export function OctoLoaderInline({ size = 16 }: { size?: number }) {
  return <SystemLoadingSurface as="span" aria-hidden="true" className="system-loading-compact inline-block shrink-0 rounded" style={{width: size, height: size}} />;
}
export const LepusLoaderInline = OctoLoaderInline;
